import React from 'react'
import type { Icon } from 'shared/utils'

const Question = (props: Icon) => {
    const {
        color = 'white',
        background = 'black',
        size = 24,
        className = 'question'
    } = props
    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 24 24"
            preserveAspectRatio="none">
            <path
                id="background"
                fillRule="nonzero"
                fill={background}
                d="M19.059 4.917C15.147 1.018 8.815 1.029 4.917 4.94c-3.899 3.912-3.888 10.244.024 14.142a9.999 9.999 0 0 0 14.118 0c3.912-3.898 3.923-10.23.024-14.142a9.978 9.978 0 0 0-.024-.024z"
            />
            <path
                id="color"
                fill={color}
                d="M11.75 15.563a.937.937 0 1 1 0 1.874.937.937 0 0 1 0-1.875zm.036-.938a.951.951 0 0 1-.946-.955c0-1.27 1.114-2.238 2.203-3.017.339-.243.713-1.046.503-1.704-.207-.65-1.026-1.038-1.7-1.038-.739 0-1.655.346-2.012 1.316a.945.945 0 0 1-1.217.563.957.957 0 0 1-.557-1.228C8.632 7.006 10.118 6 11.846 6h.002c1.366 0 3.008.812 3.502 2.364.477 1.5-.257 3.164-1.211 3.846-1.27.907-1.406 1.324-1.406 1.46a.951.951 0 0 1-.947.955z"
            />
        </svg>
    )
}

export { Question }
